/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import LogModel from 'cio/models/log';

interface ActivityLogRowTimestampArgs {
  log: LogModel;
  timestampAttribute: string;
  displayExpansionArrow: boolean;
  alignText: 'left' | 'right';
  expanded: boolean;
}

export default class ActivityLogRowTimestamp extends Component<ActivityLogRowTimestampArgs> {
  get alignText() {
    return this.args.alignText ?? 'right';
  }

  get timestampAttribute() {
    return this.args.timestampAttribute ?? 'timestamp';
  }
}
